import { BlurTargetView, BlurView } from "@-/com.npmjs.expo-blur";
import { View } from "@-/com.npmjs.react-native";
import { withUniwind } from "@-/com.npmjs.uniwind";
import { useRef, type ReactNode } from "react";

const UniwindBlurView = withUniwind(BlurView);
const UniwindBlurTargetView = withUniwind(BlurTargetView);

/**
 * Lightly blurs a premium-locked level body. The content stays recognizable as a preview but is
 * hidden from accessibility and never receives touches.
 */
export function LockedLevelBlur({ children }: { children: ReactNode }) {
  const blurTarget = useRef<View>(null);
  return (
    <View className="relative overflow-hidden">
      <UniwindBlurTargetView
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        pointerEvents="none"
        ref={blurTarget}
      >
        {children}
      </UniwindBlurTargetView>
      <UniwindBlurView
        accessibilityElementsHidden
        blurMethod="dimezisBlurView"
        blurReductionFactor={4}
        blurTarget={blurTarget}
        className="absolute inset-0"
        importantForAccessibility="no-hide-descendants"
        intensity={6}
        pointerEvents="none"
        tint="default"
      />
    </View>
  );
}
